import { Icon } from '~/components/icon'
import { useRadioContext } from '../../radio'
import type { RadioHelperTextProps, RadioScopedProps } from '../../radio.types'
import { RadioHelperTextVariants } from './index.styles'

export const RadioHelperText = ({
  children,
  __scopeRadio,
  ...props
}: RadioScopedProps<RadioHelperTextProps>) => {
  const {
    error,
    size = 'lg',
    iconOnly,
  } = useRadioContext('RadioHelperText', __scopeRadio)

  if (!error) return null

  return (
    <>
      {!iconOnly && (
        <div
          {...props}
          className={RadioHelperTextVariants({
            size,
          })}
        >
          <Icon
            symbol="rdicon-warning-circle"
            color="colorTextDangerAlternative"
            size="tiny"
          />
          <span className="line-clamp-2">{children}</span>
        </div>
      )}
    </>
  )
}
